import RocketEffect from '~/webpack/rocket-effect-loader'

const {addiesaas, vuestrap, EventBus, Vue} = RocketEffect

import '../init'

import config from '~/vuestrap/config'

import router from '../router'

addiesaas.spa = addiesaas.spa || {
  ...config,
  instances: [],
  async init(el, options) {
    const strap = {...vuestrap, ...options || {}, router, el}

    EventBus.$emit('addiesaas.app.beforeInit', el, addiesaas, strap)

    const instance = new Vue(strap);
    window.addiesaas.spa.instances.push(instance)

    EventBus.$emit('addiesaas.app.init', instance, addiesaas, strap)

    return instance
  },
}

